/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserUserType } from './ApiUserUserType';
import {
    ApiUserUserTypeFromJSON,
    ApiUserUserTypeFromJSONTyped,
    ApiUserUserTypeToJSON,
    ApiUserUserTypeToJSONTyped,
} from './ApiUserUserType';

/**
 * 
 * @export
 * @interface ApiUser
 */
export interface ApiUser {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    photo_url?: string;
    /**
     * 
     */
    user_type?: ApiUserUserType;
}

/**
 * Check if a given object implements the ApiUser interface.
 */
export function instanceOfApiUser(value: object): value is ApiUser {
    return true;
}

export function ApiUserFromJSON(json: any): ApiUser {
    return ApiUserFromJSONTyped(json, false);
}

export function ApiUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'title': json['title'] == null ? undefined : json['title'],
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
        'user_type': json['user_type'] == null ? undefined : ApiUserUserTypeFromJSON(json['user_type']),
    };
}

export function ApiUserToJSON(json: any): ApiUser {
    return ApiUserToJSONTyped(json, false);
}

export function ApiUserToJSONTyped(value?: ApiUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'photo_url': value['photo_url'],
        'user_type': ApiUserUserTypeToJSON(value['user_type']),
    };
}

